import { useState } from 'react';
import { Button, Col, Container, FloatingLabel, Form, Row, Spinner } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import Styles from '../styles/common/pages.module.css';
import Style from '../styles/pages/contact-us.module.css';
import { ContactUsHelper } from '../helpers/pages/contact-helper';

const ContactUs = () => {
    const {
        values,
        formErrors,
        handleContactus,
        isProcessing,
        handleChange
    } = ContactUsHelper();

    // Separate states for each label's active state
    const [nameActive, setNameActive] = useState(false);
    const [textActive, setTextActive] = useState(false);
    const [emailActive, setEmailActive] = useState(false);

    return (
        <>
            <Helmet>
                <title>Contact Us - Mohit's Shopping App</title>
                <meta
                    name="description"
                    content="Get in touch with Mohit's Shopping App for support, inquiries, or feedback. Reach us by email or phone for assistance."
                />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta property="og:title" content="Contact Us - Mohit's Shopping App" />
                <meta
                    property="og:description"
                    content="Need assistance? Contact Mohit's Shopping App for any support, inquiries, or feedback."
                />
                <meta
                    property="og:image"
                    content={`${process.env.PUBLIC_URL}/favicon.png`}
                />
                <meta
                    property="og:url"
                    content="https://mohit-online-shopping.netlify.app/contact-us"
                />
            </Helmet>

            {/* Main Heading of the Contact Us Page */}
            <h1 className="visually-hidden">Contact Us - Mohit's Shopping App</h1>

            <section className={Styles.headSec}>
                <Container>
                    <h2>Contact Us</h2>
                </Container>
            </section>

            <section className={Style.contantSec}>
                <Container fluid>
                    <Row className={`justify-content-center align-items-center`}>
                        <Col className={`d-flex justify-content-center`} xs={12} md={8} lg={6}>
                            <div className={Style.formWrapper}>
                                <h1>Contact Us</h1>
                                <Form onSubmit={handleContactus}>
                                    <Form.Group>
                                        <FloatingLabel
                                            controlId="floatingInput"
                                            label="Your Name"
                                            className={`${Style.floatingLabel} ${nameActive ? Style.floatingLabelActive : ''}`}
                                        >
                                            <Form.Control
                                                type="text"
                                                placeholder="Your Name"
                                                name="name"
                                                className={Style.input}
                                                autoComplete="off"  // Use camelCase for JSX
                                                onFocus={() => setNameActive(true)}
                                                onBlur={(e) => setNameActive(e.target.value !== '')}
                                                value={values.name}
                                                onChange={handleChange}
                                                disabled={isProcessing} // Disable when processing
                                            />
                                        </FloatingLabel>
                                    </Form.Group>
                                    <Form.Group>
                                        <FloatingLabel
                                            controlId="floatingInput"
                                            label="Your Email"
                                            className={`${Style.floatingLabel} ${emailActive ? Style.floatingLabelActive : ''}`}
                                        >
                                            <Form.Control
                                                type="email"
                                                placeholder="Email"
                                                name="email"
                                                className={Style.input}
                                                autoComplete="off"  // Use camelCase for JSX
                                                onFocus={() => setEmailActive(true)}
                                                onBlur={(e) => setEmailActive(e.target.value !== '')}
                                                value={values.email}
                                                onChange={handleChange}
                                                disabled={isProcessing} // Disable when processing
                                            />
                                        </FloatingLabel>
                                    </Form.Group>
                                    <Form.Group>
                                        <FloatingLabel
    controlId="floatingTextarea2"
    className={`${Style.floatingLabel} ${textActive ? Style.floatingLabelActive : ''}`}
    label="Product Link / Comment"
>
    <Form.Control
        as="textarea"
        name="comment"
        placeholder="Product not available? Paste the normal product link here, and we'll convert it into an affiliate link for you."
        className={`${Style.input} ${Style.textArea}`}
        autoComplete="off"
        onFocus={() => setTextActive(true)}
        onBlur={(e) => setTextActive(e.target.value !== '')}
        value={values.comment}
        onChange={handleChange}
        disabled={isProcessing}
    />
</FloatingLabel>
                                    </Form.Group>
                                    <Button
                                        type="submit"
                                        className={Styles.contactBtn}
                                        disabled={isProcessing}>
                                        {Object.keys(formErrors).length > 0 ? (
                                            'Send Message'
                                        ) : isProcessing ? (
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                className={Styles.customSpinner} // Applying custom spinner styles here
                                            />
                                        ) : (
                                            'Send Message'
                                        )}
                                    </Button>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>



















            {/* <section>
                <Container className={Style.container}>
                    <Row className="justify-content-center">
                        <Col md={6}>
                            <Form onSubmit={handleSubmit}>
                                <h2 className={Style.heading}>Get in Touch</h2>
                                <p className={Style.description}>
                                    Feel free to drop us a line below!
                                </p>

                                <Form.Group controlId="formName">
                                    <Form.Label>Your Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        required
                                    />
                                </Form.Group>

                                <Form.Group controlId="formEmail">
                                    <Form.Label>Your Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </Form.Group>

                                <Form.Group controlId="formMessage">
                                    <Form.Label>Your Message</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        required
                                    />
                                </Form.Group>

                                <Button variant="primary" type="submit">
                                    Send Message
                                </Button>
                            </Form>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section>
                <Container>
                    <p>Our Contact Us page is currently under construction. We're here to help! In the meantime, please feel free to reach out via email at <a href="https://mohit-online-shopping.netlify.app/">mohit-online-shopping.netlify.app</a> or call us at (123) 456-7890. Thank you for your patience!</p>
                </Container>
            </section>
            <section>
                <Container>
                    <p>We're building a better way for you to connect with us! Our Contact Us page will be available soon. For immediate assistance, please email <a href="https://mohit-online-shopping-testing.netlify.app/">mohit-online-shopping-testing.netlify.app</a> or call (123) 456-7890. We look forward to hearing from you!</p>
                </Container>
            </section> */}
        </>
    )
}

export default ContactUs
